module.exports = __webpack_public_path__ + "static/JoaoPedroMartins_Curriculo-8ac8eb43d86e0a99e5717e67e8de1060.pdf";